<template>
  <div class="w-full overflow-hidden py-8">
    <div class="relative h-24" style="mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent)">
      <div class="absolute flex animate-scroll">
        <!-- Render the logos twice for a seamless loop -->
        <div v-for="n in 2" :key="n" class="flex-shrink-0 flex items-center justify-around min-w-full">
          <div v-for="(item, index) in logos" :key="index" class="px-8 md:px-12">
            <a :href="item.url" target="_blank" rel="noopener noreferrer">
              <img :src="item.logo_url" :alt="item.alt_text" class="max-h-16 h-full object-contain">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfiniteScrollTemplate",
  props: {
    logos: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.animate-scroll {
  /* Adjust the duration based on the number of logos to maintain a consistent speed */
  animation: scroll 40s linear infinite;
}
</style>
